const DEFAULT_HEADER_OFFSET = 80;
const MAX_ATTEMPTS = 50;
const RETRY_MS = 100;
const SETTLE_DELAYS_MS = [200, 500, 900, 1400];

function getScrollTop(anchorId, headerOffset) {
  const el = document.getElementById(anchorId);
  if (!el) return null;
  return Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerOffset);
}

function applyScroll(anchorId, headerOffset, behavior) {
  const top = getScrollTop(anchorId, headerOffset);
  if (top == null) return false;
  window.scrollTo({ top, behavior });
  return true;
}

/**
 * Scroll to a page section by id, offset for the fixed site header.
 * Use settle: true when content above the target may still be loading.
 */
export function scrollToSection(anchorId, options = {}) {
  const {
    behavior = 'smooth',
    headerOffset = DEFAULT_HEADER_OFFSET,
    attempt = 0,
    settle = false,
  } = options;

  const scrolled = applyScroll(anchorId, headerOffset, attempt === 0 ? behavior : 'auto');
  if (!scrolled) {
    if (attempt < MAX_ATTEMPTS) {
      window.setTimeout(
        () => scrollToSection(anchorId, { ...options, attempt: attempt + 1 }),
        RETRY_MS
      );
    }
    return false;
  }

  if (settle) {
    SETTLE_DELAYS_MS.forEach((delay) => {
      window.setTimeout(() => {
        applyScroll(anchorId, headerOffset, 'auto');
      }, delay);
    });
  }

  return true;
}

export function scrollToRouteHash(route, options = {}) {
  const hash = (route.hash || '').replace(/^#/, '');
  if (!hash) return;
  scrollToSection(hash, { settle: true, behavior: 'auto', ...options });
}

export const UPSKILLING_COURSES_HASH = 'upskilling-courses';

export function isUpskillingCoursesHash(route) {
  return (route.hash || '').replace(/^#/, '') === UPSKILLING_COURSES_HASH;
}
